import { Component, Input, computed, inject, signal } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CommonModule } from '@angular/common';
import { Article } from '../../../models/Article';
import { GeneralService } from '../../../service/general.service';

@Component({
  selector: 'app-export-articles-excel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './export-articles-excel.html'
})
export class ExportArticlesExcelComponent {

  private _articles = signal<Article[]>([]);

  @Input() set articles(value: Article[]) {
    this._articles.set(value ?? []);
  }

  @Input() secciones: any[] = [];
  @Input() divisiones: any[] = [];
  @Input() clases: any[] = [];
  @Input() productos: any[] = [];
  @Input() variedades: any[] = [];

  hasData = computed(() => this._articles().length > 0);
  unidadesMedida = signal<any[]>([]);
  private generalService = inject(GeneralService);


  private getName(list: any[], id: number | null): string {
    if (!id) return '';

    const nombre = list.find(x => x.codigo === id)?.nombre ?? '';

    return this.capitalizarInicial(nombre);
  }
  ngOnInit() {
    this.generalService
      .get('GET_UNIDADES_MEDIDA')
      .subscribe(r => {
        console.log('UNIDADES MEDIDA:', r);
        this.unidadesMedida.set(r);
      });
  }

  exportExcel(): void {
    const rows = this._articles().map(a => ({
      'Código INE Sección': this.getCodigoIne(this.secciones, a.fkSeccion),

      'Sección': this.getName(this.secciones, a.fkSeccion),
      'Código INE División': this.getCodigoIne(this.divisiones, a.fkDivision),

      'División': this.getName(this.divisiones, a.fkDivision),
      'Código INE Clase': this.getCodigoIne(this.clases, a.fkClase),

      'Clase': this.getName(this.clases, a.fkClase),
      'Código INE Producto': this.getCodigoIne(this.productos, a.fkProducto),

      'Producto': this.getName(this.productos, a.fkProducto),
      'Código INE Variedad': this.getCodigoIne(this.variedades, a.fkVariedad),

      'Variedad': this.getName(this.variedades, a.fkVariedad),
      'Código INE': a.codigoIne,
      'Nombre': this.capitalizarInicial(a.nombre),
      'Unidad de Medida': this.getUnidadMedidaName(a.fkUnidadMedida),
      'Factor Conversión': a.factorConversion,
      'Cálculo': a.calculo === 'S' ? 'Sí' : 'No',
      'Cálculo Alterno': a.calculoAlterno === 'S' ? 'Sí' : 'No',
      'Permite cotizar en Dólares': a.cotizarEnDolares === 'S' ? 'Sí' : 'No',
      'CIIU': a.codigoCiiu,
      'NAEG': a.codigoNaeg,
      'NPG': a.codigoNpg,
      'CCP': a.codigoCcp,
      'Referencia': a.referencia,
      'Estado': a.estado === 'A' ? 'Activo' : 'Inactivo',

    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Artículos');

    const buffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    saveAs(
      new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      `articulos_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  }
  getUnidadMedidaName(id: number | null | undefined): string {
  if (id === null || id === undefined) return '';

  const unidad = this.unidadesMedida().find(u =>
    Number(u.pk) === Number(id) ||
    Number(u.codigo) === Number(id) ||
    Number(u.id) === Number(id) ||
    Number(u.pkUnidadMedida) === Number(id)
  );

  return this.capitalizarInicial(
    unidad?.descripcion ??
    unidad?.nombre ??
    unidad?.nombreUnidadMedida ??
    unidad?.unidadMedida ??
    ''
  );
}
  private getCodigoIne(list: any[], id: number | null): string {
    if (!id) return '';

    const item = list.find(x => x.codigo === id);

    return item?.codigoIne
      ?? item?.codigo_ine
      ?? item?.codigoINE
      ?? '';
  }
  private capitalizarInicial(valor: any): string {
    if (!valor) return '';

    const texto = String(valor).toLowerCase();

    return texto.charAt(0).toUpperCase() + texto.slice(1);
  }


}
